import { forwardRef } from 'react'
import { Link } from 'react-router-dom'
import { useLanguage, localizePath } from '../contexts/LanguageContext'

// Drop-in replacement for react-router's Link that keeps the visitor in their
// current language: on Greek pages, to="/pricing" points at /el/pricing.
const LocalizedLink = forwardRef(({ to, ...props }, ref) => {
  const { lang } = useLanguage()
  const target = typeof to === 'string' && to.startsWith('/') ? localizePath(to, lang) : to
  return <Link ref={ref} to={target} {...props} />
})

LocalizedLink.displayName = 'LocalizedLink'

export default LocalizedLink
